import React from "react";
import Header from "./HeaderHome";
import Footer from "./Footer";
import { useTranslation } from "react-i18next";

function Support({ changeLanguage }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col w-full relative bg-[#f7f4ed] dark:bg-[#202020]">
      <Header changeLanguage={changeLanguage} />

      <div className="flex flex-col items-center justify-center min-h-screen px-4">
        <div className="w-full max-w-2xl bg-white dark:bg-black rounded-3xl shadow-xl p-8 text-center">
          <h2 className="text-4xl text-black dark:text-[#cfcfcf] font-gnarly-semibold mb-6">
            {t("support_title")}
          </h2>

          <p className="text-lg text-gray-700 dark:text-gray-300 mb-8">
            {t("support_description")}
          </p>

          <a
            href="mailto:support@flateroo.com"
            className="text-xl text-blue-600 dark:text-blue-400 hover:underline font-medium"
          >
            support@flateroo.com
          </a>
        </div>
      </div>

      <div className="w-full mt-20">
        <Footer />
      </div>
    </div>
  );
}

export default Support;
